import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../../components/global/Button';
import EditIcon from '../../../../../../../../components/icons/EditIcon';

const propTypes = {
  values: PropTypes.shape({
    relationship: PropTypes.string,
  }),
  steps: PropTypes.object,
  onUpdate: PropTypes.func,
};

const WeddingEventReviewDetails = ({ values, steps, onUpdate }) => {
  const albums = values.albums.filter(album => album.selected);

  return (
    <>
      <tr>
        <td className="text-left">
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column mr-1">
              <h3 className="mb-0">Albums</h3>
              <p className="text-base">
                {albums.map(album => album.name).join(', ') || 'N/A'}
              </p>
            </div>
            <Button
              btnStyle="link"
              className="ml-auto review-step-edit-icon"
              btnSize="sm"
              onClick={event => {
                event.preventDefault();
                onUpdate(event, steps.ALBUMS);
              }}
            >
              <EditIcon color="#0d84fe" size="16px" className="ml-1" />
            </Button>
          </div>
        </td>
      </tr>
      <tr>
        <td className="text-left">
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column mr-1">
              <h3 className="mb-0">Contact info</h3>
              <p className="text-base">
                {values.bride_name || 'Luis'} &amp;{' '}
                {values.groom_name || 'Liliana'}{' '}
                {values.couple_email_address && (
                  <> &ndash; {values.couple_email_address}</>
                )}
                {values.email_address && <> &ndash; {values.email_address}</>}
              </p>
            </div>
            <Button
              btnStyle="link"
              btnSize="sm"
              onClick={onUpdate}
              className="ml-auto review-step-edit-icon"
            >
              <EditIcon color="#0d84fe" size="22px" className="ml-1" />
            </Button>
          </div>
        </td>
      </tr>
    </>
  );
};

WeddingEventReviewDetails.propTypes = propTypes;

export default WeddingEventReviewDetails;
